import styled from "@emotion/styled";
import { Menu, MenuItem } from "react-aria-components";

export const StyledMenu = styled(Menu)`
  min-width: 176px;
  max-width: min(288px, 90vw);
`;

export const StyledMenuItem = styled(MenuItem)();
